import { loadStripe } from '@stripe/stripe-js';

// Load Stripe with publishable key from environment
// Make sure to add VITE_STRIPE_PUBLISHABLE_KEY to your .env file
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

if (!stripePublishableKey) {
  console.warn('⚠️ VITE_STRIPE_PUBLISHABLE_KEY not found in environment variables');
}

export const stripePromise = loadStripe("pk_live_51QzzTfKTTvLJ1QzfbLKyssl1laLS7kARagzkepTFkA2evxlk1ZLtvBsG6Qjl3497X2FLQwuwxzd791DAxGVEZZ3k00jbG3Rv3P");

export default stripePromise;
